import { DEFAULT_CHAIN } from '@package/smart-wallet/constants';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { ChainStore } from './ChainStore.interface';

export const useChainStore = create(
  devtools(
    persist<ChainStore>(
      (set) => ({
        chainId: DEFAULT_CHAIN.id,
        switchNetwork: (chainId: number) => set({ chainId }),
      }),
      { name: 'superwallet-chain' },
    ),
  ),
);
